/**
 * @module libs/filters
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * React-table filter extensions
 */

import React, { useMemo } from 'react';
import { FormControl } from 'react-bootstrap';

import { useLanguageState } from '../contexts/LanguageProvider';


export const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  const [ lang ] = useLanguageState();

  const count = preFilteredRows.length;
  return (
    <FormControl
      value={filterValue || ''}
      onChange={e => {
        // Set undefined to remove the filter entirely
        setFilter(e.target.value || undefined)
      }}
      style={{width:'100%'}}
      placeholder={`${lang.search} ${count} ${lang.records}...`}
    />
  )
};


export const SelectMultipleColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [ lang ] = useLanguageState();

  // Calculate the options for filtering
  // using the preFilteredRows
  const options = useMemo(() => {
    const options = new Set()
    preFilteredRows.forEach(row => {
      options.add(row.values[id])
    })
    return [...options.values()]
  }, [id, preFilteredRows])

  return (
    <FormControl
      componentClass='select'
      value={filterValue}
      multiple
      size={3}
      onChange={e => {
        const options = Array.from(e.target.options).filter(
          option => option.selected
        ).map(option => option.value);
        setFilter(options || undefined)
      }}
    >
      <option value="">{lang.all}</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </FormControl>
  )
}


// Define a custom filter filter function!
export const filterMultipleIncludes = (rows, id, filterValue) => {
  return rows.filter(row => {
    return filterValue.indexOf("") < 0 ? filterValue.indexOf(row.values[id]) > -1 : true;
  })
};


export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [ lang ] = useLanguageState();

  // Calculate the options for filtering
  // using the preFilteredRows
  const options = useMemo(() => {
    const options = new Set()
    preFilteredRows.forEach(row => {
      options.add(row.values[id])
    })
    return [...options.values()]
  }, [id, preFilteredRows])

  return (
    <FormControl
      componentClass='select'
      value={filterValue}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
    >
      <option value="">{lang.all}</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </FormControl>
  )
};


export default DefaultColumnFilter;